import React, { useRef, useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';

export type SimInputChange = {
  valid: boolean;
  value: string;
  reset(): void;
};

type SimInputProps = {
  digits: number;
  onChange(e: SimInputChange): void;
};

function SimInput({ digits, onChange }: SimInputProps) {
  const [otp, setOtp] = useState('');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    onChange({
      value: otp,
      valid: otp.length === digits,
      reset: () => {
        setOtp('');
        ref.current?.querySelector('input')?.focus();
      },
    });
  }, [otp]);

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          } as any);
          if ((otp as any)?.code) {
            setOtp((otp as any).code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  return (
    <div className="SimInput" ref={ref}>
      <OtpInput
        value={otp}
        onChange={(val) => setOtp(val)}
        numInputs={digits}
        shouldAutoFocus
        inputStyle="SimInput__input"
        containerStyle="SimInput__container"
        renderInput={(inputProps, index) => (
          <input
            {...inputProps}
            key={index}
            inputMode="numeric"
            pattern="[0-9]*"
          />
        )}
      /> 
    </div>
  );
}

export default SimInput;
